export type SubLinkType = {
  label: string;
  link: string;
  icon: JSX.Element;
  badge?: React.ReactNode;
};

export type SubMenu = {
  header: string | JSX.Element;
  links: SubLinkType[];
};

export type LinkType = {
  icon: JSX.Element;
  label: string;
  link?: string;
  items?: SubLinkType[];
  badge?: React.ReactNode;
};

export enum CategoryType {
  CAMPAIGN = "campaign",
  MEMBER = "member",
  ACHIEVEMENT = "achievement",
  TIER = "tier",
  WALLET = "wallet",
  REWARD = "reward",
  COLLECTION = "collection",
}

export type CategoryTypeUnion = `${CategoryType}`;

export enum CategorySubType {
  LAST_NAME = "lastName",
  FIRST_NAME = "firstName",
  PHONE = "phone",
  LOYALTY_CARD_NUMBER = "loyaltyCardNumber",
  EMAIL = "email",
}

export type CategorySubTypeUnion = `${CategorySubType}`;

export type CategoryDetailsType = {
  label: "campaigns" | "members" | "achievements";
  type: CategoryType;
  items: any[];
};

export type StoredSearch = {
  link: string;
  label: string;
  category: string;
};
